import {
  Component,
  OnInit,
  AfterViewInit
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../app.service';
import { ProjectItem } from '../project/index';
import { MessageBrokerService, ErrorModel } from '../shared/core/index'
import { AuthService } from '../shared/core/auth.service';
import { IUserInfo } from '../shared/core/user-info.model';
import { SharedUtils } from '../shared/utils';
import { fadeInAnimation } from '../_animations/fade-in.animation';
import { trigger } from '@angular/animations';
import { slideInOutAnimation } from '../_animations/index';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { Subscription } from 'rxjs/Subscription';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { HttpService } from '../shared/core/http.service';
import { Observable } from 'rxjs';
import { Request, XHRBackend, RequestOptions, Http, Response, Headers } from '@angular/http';
import { ProjectService } from '../project/project.service';
import { IProject } from '../project/project.model';

@Component({
  selector: 'dashboard',
  template: require('./dashboard.component.html'),
})

export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {

  showNoProjectsMessage: boolean;
  noProjectMessage: string = 'Can\'t display the last accessed project or could not find the requested project';
  additionalNoProjectMessage: string;
  currentProjectId: string;
  project: ProjectItem = new ProjectItem();
  isDataLoading: boolean;
  currentUser: IUserInfo;
  projectDepartment: string = "";
  errorMessage: string;

  private APIUrl = process.env.API_URL;

  constructor(public route: ActivatedRoute,
    private _appService: AppService,
    private _messageBrokerService: MessageBrokerService,
    private _projectService: ProjectService,
    private router: Router,
    private _authService: AuthService,
    private _errorHandler: GlobalErrorHandler,
    private _httpService: HttpService,
  ) {
    this._authService.subscribeToLoginService().subscribe(r => { this.currentUser = r });
  }

  sub: Subscription;

  private isValid = false;

  public ngOnInit() {


    

    if (typeof this._authService.userInfo.accessToken !== 'undefined'){
      console.log('DashboardComponent.ngOnInit()');

      this.isDataLoading = true;
      localStorage.removeItem('AdvancedSearchData');
      this.sub = this.route.params.subscribe
        (
        params => {
          this._appService.isProjectLoaded = false;
          console.log('DashboardComponent.ngOnInit().this.route.params.subscribe >> params[\'projectId\']' + params['projectId']);
          this.currentProjectId = params['projectId'];
          this.loadDashboard();
        },
        err => {
          if (err.status && err.status === 401) {
            //load default project.
            this.loadDashboard();
          }else{
            this._errorHandler.processError(err);
          }
        });
    }
  }

  getUserInfo(email:string): Observable<boolean>{
        
    //if (localStorage.getItem('appToken') !== null && localStorage.getItem('userInfo') === null) {
        //let result = this._httpService.get(this.APIUrl + 'user/GetUser?email='+ email)
        //let result = this._httpService.getExtend(this.APIUrl + 'user/GetUser?email='+ email)
        //return this._httpService.httpGet(this.APIUrl + 'user/GetUsers')
        return this._httpService.httpGet(this.APIUrl + 'user/GetUsers')
            .map(res => res.json())     
            .do(res => {                
            if(res!=null){

                let userData = res;
                return true;                    
            }else{
              return false;
            }
        })
        .catch(this.handleError);
    //}
    //return Observable.of(false);
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  ngAfterViewInit(): void {
    SharedUtils.RemoveTooltipIfNeeded();
  }

  doProjectDetail(): void {
    this.router.navigate(['projectdetail', this.project.ProjectId])
  }

  getCountFrom(count: number): number {
    return 0;
  }

  loadDashboard(): void {
    this.isDataLoading = true;
    this.showNoProjectsMessage = false;

    if (!this.currentProjectId)
      this.currentProjectId = '';

    let self = this;

    this._appService.getDashboardProject(this.currentProjectId).subscribe
      (
      proj => {
        // console.log('loadDashboard():this._appService.getDashboardProject(...) >> project: ' + JSON.stringify(proj));
        
        self.isDataLoading = false;
        if (proj != null && proj.length > 0) {
          self.project = proj[0];
          this.validateTVProject(self.project.ProjectId);
          var animation = "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
          var animationEffect = "animated fadeIn";

          $('.main-container').addClass(animationEffect).one(animation, function () {
            $(self).removeClass(animationEffect);
          });
          
          self._messageBrokerService.setCurrentProject(self.project, true);
        }
      },
      err => {
        console.error('DashboardComponent.loadDashboard():' + err);
        
        self.isDataLoading = false;
        if (err.status == 404) {
          self.showNoProjectsMessage = true;
          if (self.currentProjectId) {
            self.noProjectMessage = 'The project you tried to access does not exist or has been deleted';
            self.additionalNoProjectMessage = '';
          } else {
            if (self.isClearanceUser){
              self.noProjectMessage = 'It seems there are no projects or you have not accessed any yet';
              self.additionalNoProjectMessage = 'Try searching for one first';
            }
            else  {
              self.noProjectMessage = 'You are not currently assigned to any project in this application';
              self.additionalNoProjectMessage = 'Please contact the Clearance team so that you may be added to a project';
            }
          }
          self._messageBrokerService.setCurrentProject(null);
        }
        else if(err.status == 403){
          self.showNoProjectsMessage = true;
          self.noProjectMessage = 'You do not have access to this project.';
          self.additionalNoProjectMessage = '';
        }
        else {
          self._errorHandler.processError(err);
        }
      }
      );
  }
  goToItemList(sortByField: string, sortOrder: string, status: string, filterBy: string, filterString: string): void {

    if (!sortByField)
      sortByField = 'ModifiedDate';

    //    var qp : Map<string, string> = new Map<string, string>();
    var qp: { [type: string]: string } = {}

    qp['sortBy'] = sortByField ? sortByField : 'CreatedDate';

    qp['sortOrder'] = sortOrder ? sortOrder : 'DESC';

    if (status) {
      qp['status'] = status;
    }

    if (filterBy && filterString) {
      qp['filterBy'] = filterBy;
      qp['filterString'] = filterString;
    }

    console.log('qp:' + JSON.stringify(qp));

    this.router.navigate(['projects', this.project.ProjectId, 'items'], { queryParams: qp });
  }
  createNewItem(): void {
    this._appService.listViewURL = '/dashboard/' + this.project.ProjectId;
    this.router.navigate(['projects', this.project.ProjectId, 'items', 'new'])
  }

  get isProductionUser(): Boolean {
    return this._authService.isUserInRole(process.env.PRODUCTION_ROLE) || process.env.ENV == 'development';
  }

  get isClearanceUser(): Boolean {
    return this._authService.isUserInRole(process.env.CLEARANCE_ROLE) || process.env.ENV == 'development';
  }

  validateTVProject(projectId: string): void{
    
    if(this.currentProjectId != "")
      projectId = this.currentProjectId;

    if(projectId != ""){
      this._projectService.getProject(projectId)
      .subscribe((project: IProject) => {
              this.projectDepartment = project.department;
          },
          (error: any) => {
              this.errorMessage = <any>error;
              this._errorHandler.processError(error);
          }
      );
    }
    
  }

  openEmail(emailId: string, e: Event) {
    if (emailId) {
      window.location.href = "mailto:" + emailId;
    }
    e.stopPropagation();
  }


  private handleError(error: Response) {
    // console.error('error!:' + error.json() ? error.json() : error.text);
    return Observable.throw(error || 'Server error');
}

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/dashboard/dashboard.component.ts